import Api from '@/api/api.js'

export default {
    getAllChampDmp(type_dmp) {
        const promise = Api().get('/consultations/dmp/'+type_dmp+'/champs')
        return promise.then((response) => response.data)
    },

    saveChampDMP(data) {
        const promise = Api().post('/consultations/dmp/champs/store', data)
        return promise.then((response) => response.data)
    },

    getDmpByType(data) {
        const promise = Api().get('/consultations/'+data.patient_id+'/dmp/'+data.type_dmp+'/contenu')
        return promise.then((response) => response.data)
    },

    getDmpContents() {
        const promise = Api().get('/consultations/dmp/contenus')
        return promise.then((response) => response.data)
    },

    saveConsultationDmp(data) {
        const promise = Api().post('/consultations/dmp/save/type_dmp', data)
        return promise.then((response) => response.data)
    },

    removeConsultationDmpContent(data) {
        const promise = Api().put('/consultations/dmp/remove/contenu_dmp', data)
        return promise.then((response) => response.data)
    },

    getAllPatientDmp(data) {
        const promise = Api().post('/consultations/patients/antecedents', data)
        return promise.then((response) => response.data)
    },
}